import axios from 'axios'

import { apiClient } from './client'

export type StringTable = {
  language: string
  version: number
  strings: Record<string, string>
}

export type StringTablePayload = {
  strings: Record<string, string>
  deletedIds: string[]
}

export type StringTableEditAccess = {
  canEdit: boolean
  currentEnvironment: string
  accessMode: 'staging' | 'ownerOverride' | 'automation' | 'readOnly'
  message: string
}

export const getStringTable = async (language: string): Promise<StringTable | null> => {
  try {
    const { data } = await apiClient.get<StringTable>(`/api/strings/${language}`)
    return data
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return null
    }
    throw error
  }
}

export const patchStringTable = async (language: string, payload: StringTablePayload) => {
  const { data } = await apiClient.patch<StringTable>(`/api/admin/strings/${language}`, payload)
  return data
}

export const getStringTableEditAccess = async () => {
  const { data } = await apiClient.get<StringTableEditAccess>('/api/admin/strings/edit-access')
  return data
}
